import React from "react";
import { styled } from '@mui/material/styles';
import { Box, Button, Typography } from "@mui/material";
import { Fragment } from "react";
import notFound from "../assets/Image/404.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PREFIX = 'NotFound';

const classes = {
  root: `${PREFIX}-root`,
  link: `${PREFIX}-link`,
  marginTop: `${PREFIX}-marginTop`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    transform: "translate(-50%, -50%)",
    top: "50%",
    left: "50%",
    position: "absolute",
    textAlign: "center",
  },

  [`& .${classes.link}`]: {
    textDecoration: "none",
  },

  [`& .${classes.marginTop}`]: {
    marginTop: theme.spacing(2),
  }
}));

const NotFound = (props) => {

  const { t } = useTranslation();

  return (
    <Root>
      <Box className={classes.root}>
        <img src={notFound} height={120} alt="404" />
        <Typography variant="h6" className={classes.marginTop}>
          {t("pageNotFound")}
        </Typography>
        <Link className={classes.link} to="/admin">
          <Button
            className={classes.marginTop}
            variant="outlined"
            color="primary"
          >
            {t("homePage")}
          </Button>
        </Link>
      </Box>
    </Root>
  );
};

export default NotFound;
